// extracted by mini-css-extract-plugin
export var bottomCircle = "bK_hl";
export var content = "bK_bY";
export var description = "bK_dt";
export var hide = "bK_z";
export var icon = "bK_bz";
export var image = "bK_d";
export var imageContainer = "bK_hq";
export var left = "bK_bG";
export var nextYear = "bK_hp";
export var right = "bK_bH";
export var section = "bK_b";
export var shrink = "bK_hn";
export var title = "bK_f";
export var topCircle = "bK_hk";
export var wave = "bK_g1";
export var waveContainer = "bK_dY";
export var year = "bK_hm";